import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { SubscriptionPlan } from "@kells/interfaces/patient";
import { AnalyticsService } from "@kells/apis/analytics";
import {
  CloseTermsModal,
  OpenTermsModal,
} from "apps/patient-reporting/src/app/shared/models/analytics/home-events";

export interface UpgradePlanModalData {
  title?: string;
  description?: string;
  selectedPlan?: SubscriptionPlan;
  availableUpgrades?: SubscriptionPlan[];
}

@Component({
  selector: "koa-terms-modal",
  templateUrl: "./terms-modal.component.html",
  styleUrls: ["./terms-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsModalComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<TermsModalComponent>,
    private readonly analyticsService: AnalyticsService
  ) {}

  ngOnInit(): void {
    this.analyticsService.record(OpenTermsModal({}));
  }

  public closeDialog() {
    this.analyticsService.record(CloseTermsModal({}));
    this.dialogRef.close();
  }
}
